import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-chequesetupmodal',
  templateUrl: './chequesetupmodal.component.html',
  styleUrls: ['./chequesetupmodal.component.css']
})
export class ChequesetupmodalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
